export default (state, action) => {
  switch (action.type) {
    case 'FETCH_ORDER_TRACKING': {
      return { ...state, loading: true }
    }
    case 'FETCH_ORDER_TRACKING_SUCCESS': {
      var result = {
        ...state,
        orders: action.payload.data.orders,
        loading: false
      }

      return result
    }
    case 'FETCH_ORDER_TRACKING_FAIL': {
      return {
        ...state,
        hasMoreItems: false,
        error:
          action.request && action.request.status !== 404 ? 'Error' : undefined,
        ready: true,
        loading: false
      }
    }
    case 'GET_ORDERLIST': {
      return {
        ...state,
        loading: true
      }
    }
    case 'GET_ORDERLIST_SUCCESS': {
      var orderstracking = (state &&
      state.orderstracking &&
      !action.fromOrderDetail
        ? [...state.orderstracking, ...action.payload.data]
        : !action.fromOrderDetail && [...action.payload.data]
      ).reduce(
        (unique, item) => (unique.includes(item) ? unique : [...unique, item]),
        []
      )

      return {
        ...state,
        orderstracking,
        loading: false
      }
    }
    case 'INSERT_NETSHOES_LAST_EVENT': {
      return {
        ...state,
        orderstracking: (state && state.orderstracking
          ? [
            ...state.orderstracking,
            {
              orderId: action.orderId,
              statuses: [
                {
                  status: action.status,
                  name: mapOrderStatus(action.status)
                }
              ]
            }
          ]
          : [
            {
              orderId: action.orderId,
              statuses: [
                {
                  status: action.status,
                  name: mapOrderStatus(action.status)
                }
              ]
            }
          ]
        ).reduce(
          (unique, item) =>
            unique.includes(item) ? unique : [...unique, item],
          []
        ),
        loading: false
      }
    }
    case 'INSERT_NETSHOES_EVENT_TRACKING_STATUS': {
      state.tracking = state.tracking || {}
      let { id, sku, orderId } = action

      state.tracking[id] = {
        orderId,
        sku,
        statuses: [
          {
            status: action.status,
            name: mapOrderStatus(action.status)
          }
        ]
      }

      return {
        ...state,
        loading: false
      }
    }
    case 'FETCH_PRODUCTS_TRACKING': {
      return { ...state, loading: true, hasMoreItems: true }
    }
    case 'FETCH_PRODUCTS_TRACKING_SUCCESS': {
      var orderItems =
        (state && action.pageIndex !== 1 && state.orderItems) || []
      orderItems = [...orderItems, ...action.payload.data.orderItems]
      return {
        ...state,
        orderItems,
        totalRows: action.payload.data.totalRows,
        loading: false,
        hasMoreItems: orderItems.length < action.payload.data.totalRows
      }
    }
    case 'FETCH_PRODUCTS_TRACKING_FAIL': {
      return {
        ...state,
        hasMoreItems: false,
        error:
          action.request && action.request.status !== 404 ? 'Error' : undefined,
        ready: true,
        loading: false
      }
    }
    case 'GET_TRACKING_STATUS': {
      let { id } = action

      state.tracking = state.tracking || {}

      if (!state.tracking[id]) state.tracking[id] = { loading: true }

      return {
        ...state
      }
    }
    case 'GET_TRACKING_STATUS_SUCCESS': {
      if (!state.tracking) return { ...state }

      var data = action.payload.data || {}
      data.trackingVtexCourier = 'teste'
      data.trackingVtexId = 1
      data.trackingVtexNumber = '1231231'
      data.trackingVtexUrl = 'http://'
      state.tracking[action.meta.previousAction.id] = data

      return {
        ...state
      }
    }
    case 'GET_TRACKING_STATUS_FAIL': {
      if (!state.tracking) return { ...state }

      state.tracking[action.meta.previousAction.id] = { erro: true }

      return {
        ...state
      }
    }
    case 'INSERT_TRACKING_STATUS': {
      state.tracking = state.tracking || {}
      let { id, sku, orderId, status } = action

      state.tracking[id] = {
        orderId,
        sku,
        statuses: status
      }

      return {
        ...state,
        loading: false
      }
    }
    default:
      return { ...state }
  }
}

const mapOrderStatus = orderStatus => {
  var status
  switch (orderStatus) {
    case 1:
      status = 'Confirmado'
      break
    case 2:
      status = 'Pendente'
      break
    case 3:
      status = 'Estornado'
      break
    case 4:
      status = 'Pendente'
      break
    case 5:
      status = 'Confirmado'
      break
    case 6:
      status = 'Cancelado'
      break
    case 7:
      status = 'Estornado'
      break
    case 8:
      status = 'Cancelado'
      break
    case 9:
      status = 'Pendente'
      break
    case 10:
      status = 'Cancelado'
      break
    case 11:
      status = 'Cancelado'
      break
    case 12:
      status = 'Confirmado'
      break
    case 13:
      status = 'Cancelado'
      break
    case 14:
      status = 'Cancelado'
      break
    case 15:
      status = 'Cancelado'
      break
    case 16:
      status = 'Cancelado'
      break
    case 17:
      status = 'Pendente'
      break
    case 18:
      status = 'Estornado'
      break
    case 19:
      status = 'Estornado'
      break
  }
  return status
}



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/reducer.js